// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1-dqt","productName":"Table_productName__2Fn6T"};